module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Semibold.1557c49b.ttf";